// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g4Go","index":"styles_index__1pgA7"};